export const isMobile = () => window.innerWidth < 1024;

export const isTouchDevice = () => window.matchMedia('(pointer: coarse) and (hover: none)').matches;

export const flatAndSort = (object, key) => {
  const keys = Object.keys(object);
  const sortedKeys = keys.sort((a, b) => object[a][key] - object[b][key]);
  const sortedObject = [];
  sortedKeys.forEach(k => sortedObject.push({ key: k, ...object[k] }));
  return sortedObject;
};

export const isSafari = () => navigator.vendor && navigator.vendor.indexOf('Apple') > -1
  && navigator.userAgent
  && navigator.userAgent.indexOf('CriOS') === -1
  && navigator.userAgent.indexOf('FxiOS') === -1;

export const isIOS = () => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
